const apis: Record<string, string> = {
  'http://localhost:3000': 'http://localhost:5075',
  'https://localhost:3000': 'http://localhost:5075',
  'https://dev-portal.avonova.se': 'https://dev-portal-api.avonova.se',
  'https://test-portal.avonova.se': 'https://test-portal-api.avonova.se',
  'https://portal.avonova.se': 'https://portal-api.avonova.se',
};

const envrionments: Record<string, string> = {
  'https://localhost:3000': 'Localhost',
  'https://dev-portal.avonova.se': 'Development',
  'https://test-portal.avonova.se': 'Test',
  'https://portal.avonova.se': 'Production',
};

const publicFilesBucket: Record<string, string> = {
  'https://localhost:3000': 'avonova-public-dev',
  'https://dev-portal.avonova.se': 'avonova-public-dev',
  'https://test-portal.avonova.se': 'avonova-public-test',
  'https://portal.avonova.se': 'avonova-public',
};

const test = ``;

export default {
  APIUrl: `${apis[location.origin]}/api`,
  AuthRedirectUri: '/login',
  Env: `${envrionments[location.origin] || 'Unknown'}`,
  PublicFilesBaseUri: `https://${publicFilesBucket[location.origin]}.obs.eu-de.otc.t-systems.com`,
};
